import { http, HttpResponse, delay } from 'msw';
import { mockSettings } from './mockSettings';

const isTestEnv = () => process.env.NODE_ENV === 'test';

const dynamicDelay = () => (isTestEnv() ? 1 : mockSettings.networkDelay);

export const mfaPhoneNumberHandlers = [
	http.post('*/api/Verification/ValidateOtp', async ({ request }) => {
		const { token, oneTimePassword, medium } = await request.json();
		if (mockSettings.returnError) {
			return new HttpResponse(null, {
				status: 503,
			});
		}

		// Validate the request body
		if (!token || !oneTimePassword || !medium) {
			return HttpResponse.json(
				{
					responseStatus: {
						message: 'Incorrect One-Time-Password',
					},
				},
				{
					status: 400,
				}
			);
		}

		// Simulate successful auth
		return HttpResponse.json({
			code: 'codeFromVerificationValidateOtp',
			redirectUri: 'https://httpbin.org/post',
		});
	}),
	http.post('*/api/MfaSettings/UpdateContactInfo', async ({ request }) => {
		const { type, value, token } = await request.json();
		if (mockSettings.returnError) {
			return new HttpResponse(null, {
				status: 500,
			});
		}
		await delay(dynamicDelay());

		if (type === 'Email') {
			if (token && value) {
				return HttpResponse.json({
					sendRateLimit: mockSettings?.returnNullValue ? null : 60,
				});
			}
			return HttpResponse.json(
				{
					responseStatus: {
						message: 'Please enter a valid email address',
					},
				},
				{ status: 400 }
			);
		}

		if (type === 'PhoneNumber') {
			if (token && value) {
				return HttpResponse.json({
					sendRateLimit: mockSettings?.returnNullValue ? null : 60,
				});
			}
			return HttpResponse.json(
				{
					responseStatus: {
						message: 'Please enter a valid 10-digit phone number',
					},
				},
				{ status: 400 }
			);
		}

		// Return a default response if type is neither 'Email' nor 'PhoneNumber'
		return HttpResponse.json(
			{
				responseStatus: {
					message: 'Invalid contact type',
				},
			},
			{ status: 400 }
		);
	}),
	http.post('*/api/Mfa/Authorization', async ({ request }) => {
		const { password } = await request.json();
		if (mockSettings.returnError) {
			return new HttpResponse(null, {
				status: 500,
			});
		}
		if (password === 'error') {
			return new HttpResponse(null, {
				status: 500,
			});
		}
		await delay(dynamicDelay());
		return password
			? HttpResponse.json({
					token: mockSettings?.returnNullValue ? null : 'TestToken',
			  })
			: HttpResponse.json({ token: '' });
	}),
	http.get('*/api/Mfa/Settings', async () => {
		if (mockSettings.returnError) {
			return new HttpResponse(null, {
				status: 500,
			});
		}
		await delay(dynamicDelay());

		return HttpResponse.json({
			settings: {
				enabled: !mockSettings.disableMFAFeatures,
				sms: {
					address: mockSettings.mfaPhoneNumberVerification
						? '(555)123-4567'
						: null,
					medium: 'SMS',
					status: mockSettings.mfaPhoneNumberVerification,
				},
				email: {
					address: mockSettings.mfaEmailVerification ? 'test@gmail.com' : null,
					medium: 'Email',
					status: mockSettings.mfaEmailVerification,
				},
			},
		});
	}),
	http.post('*/api/MfaSettings/Toggle', async () => {
		await delay(dynamicDelay());
		if (mockSettings.returnMFAStatusToggleError) {
			return new HttpResponse(null, {
				status: 500,
			});
		}
		return HttpResponse.json({});
	}),
];
